const PartnerActionTypes = {
}
export default PartnerActionTypes
